import { styled } from '../../system';
export const Container = styled('div', {
    w: '$full',
    mr: 'auto',
    ml: 'auto',
    variants: {
        variant: {
            fluid: {
                maxW: '$full'
            },
            responsive: {
                '@xs': {
                    maxW: '$full'
                },
                '@sm': {
                    maxW: '$sizes$containerSm'
                },
                '@md': {
                    maxW: '$sizes$containerMd'
                },
                '@lg': {
                    maxW: '$sizes$containerLg'
                },
                '@xl': {
                    maxW: '$sizes$containerXl'
                },
                '@2xl': {
                    maxW: '$sizes$container2xl'
                }
            }
        },
        gap: {
            true: {
                px: '$sizes$containerPadding'
            },
            false: {
                px: 0
            }
        }
    },
    defaultVariants: {
        variant: 'responsive',
        gap: true
    }
});
Container.displayName = 'Container';
